"use client";

import React from "react";
import { useVoiceSelect } from "@/components/common/voice-selector/hooks/use-voice-select";
import VoiceSelectorBase from "@/components/common/voice-selector/selectors/base/voice-selector-base";
import DefaultTopBar from "@/components/common/voice-selector/top-bars/default-top-bar";

const DefaultVoiceSelector = () => {
  const {
    handleSearch,
    searchValue,
    filteredVoiceList,
    hasSearched,
    handleGenderSelect,
    handleDefaultVoiceModelClick,
    scrollUpdate,
    handleFilterSelect,
    scrollY,
    isLoading,
  } = useVoiceSelect();
  return (
    <VoiceSelectorBase
      isLoading={isLoading}
      filteredVoiceList={filteredVoiceList}
      handleVoiceModelClick={handleDefaultVoiceModelClick}
      scrollUpdate={scrollUpdate}
      hasSearched={hasSearched}
      searchValue={searchValue}
    >
      <DefaultTopBar
        handleGenderSelect={handleGenderSelect}
        handleFilterSelect={handleFilterSelect}
        handleSearch={handleSearch}
        scrollY={scrollY}
      />
    </VoiceSelectorBase>
  );
};

export default DefaultVoiceSelector;
